import { BasePage } from '@/components/ui/base-page'

export function SentiumPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add SentiumPage specific content here */}
    </BasePage>
  )
}